var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "perf-tab" },
    [
      _c(
        "ScrollPane",
        [
          _c(
            "ActionHeader",
            {
              staticClass: "no-search",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              !_vm.$shared.recordPerf
                ? _c(
                    "VueButton",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Start benchmark",
                          expression: "'Start benchmark'"
                        }
                      ],
                      staticClass: "flat",
                      attrs: { "icon-left": "lens" },
                      on: {
                        click: function($event) {
                          return _vm.start()
                        }
                      }
                    },
                    [_vm._v("\n        Start\n      ")]
                  )
                : _c(
                    "VueButton",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Stop benchmark",
                          expression: "'Stop benchmark'"
                        }
                      ],
                      staticClass: "flat stop-button",
                      attrs: { "icon-left": "lens" },
                      on: {
                        click: function($event) {
                          return _vm.stop()
                        }
                      }
                    },
                    [_vm._v("\n        Stop\n      ")]
                  ),
              _c(
                "VueSelect",
                {
                  staticClass: "saved-benchmarks-select",
                  attrs: {
                    disabled: _vm.$shared.recordPerf,
                    placeholder: "Select saved benchmark...",
                    "button-class": "flat"
                  },
                  model: {
                    value: _vm.currentBenchmarkModel,
                    callback: function($$v) {
                      _vm.currentBenchmarkModel = $$v
                    },
                    expression: "currentBenchmarkModel"
                  }
                },
                [
                  _vm._l(_vm.benchmarks, function(benchmark, index) {
                    return _c("VueSelectButton", {
                      key: index,
                      attrs: { value: benchmark, label: benchmark.label }
                    })
                  }),
                  !_vm.benchmarks.length
                    ? _c("div", { staticClass: "vue-ui-empty" }, [
                        _vm._v("\n          No saved benchmark yet\n        ")
                      ])
                    : _vm._e()
                ],
                2
              ),
              _vm.currentBenchmark && _vm.$responsive.width > 900
                ? _c("div", { staticClass: "benchmark-duration" }, [
                    _vm._v(
                      "\n        Total duration: " +
                        _vm._s(Math.round(_vm.benchmarkDuration / 1000)) +
                        "s\n      "
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "vue-ui-spacer" }),
              _c(
                "VueGroup",
                {
                  model: {
                    value: _vm.routeModel,
                    callback: function($$v) {
                      _vm.routeModel = $$v
                    },
                    expression: "routeModel"
                  }
                },
                [
                  _c("VueGroupButton", { attrs: { value: "fps" } }, [
                    _vm._v("\n          Frames per second\n        ")
                  ]),
                  _c(
                    "VueGroupButton",
                    { attrs: { value: "component-render" } },
                    [_vm._v("\n          Component render\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("router-view", { attrs: { slot: "scroll" }, slot: "scroll" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }